export * from '@primeuix/themes/nora/image';
export { default } from '@primeuix/themes/nora/image';
